export function shallAIPageKeepAlive(routerPath, meta) {
    return !!meta?.keepAlive && !/\*|:/.test(routerPath);
}
